import { render, staticRenderFns } from "./MetricsDashboard.vue?vue&type=template&id=b557b36e&scoped=true&"
import script from "./MetricsDashboard.vue?vue&type=script&lang=js&"
export * from "./MetricsDashboard.vue?vue&type=script&lang=js&"
import style0 from "./MetricsDashboard.vue?vue&type=style&index=0&id=b557b36e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b557b36e",
  null
  
)

export default component.exports